import type { LibraryItem } from '@/types/library'

/** Placeholder shown for an image node with no backing asset, or one that no longer resolves. */
export const PLACEHOLDER_IMAGE_SRC = 'https://placehold.co/640x480'

/** Finds the library item matching `assetId`, or `undefined` if it is missing or not loaded. */
export function findLibraryItemById(
  items: LibraryItem[],
  assetId: string,
): LibraryItem | undefined {
  return items.find((item) => item.id === assetId)
}
